import { Component, Input, OnChanges, OnDestroy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Subscription } from "rxjs";

import { EntitetStatus } from "@dffedb/util";

@Component({
    selector: "ejendomsfaktor",
    templateUrl: "./ejendomsfaktor.component.html"
})
export class EjendomsfaktorComponent implements OnDestroy, OnChanges {
    private unsubscribe$: Subscription;
    @Input() public formGroup: UntypedFormGroup;

    public ngOnChanges(): void {
        // Opdater ejendomsfaktorens status, så vi kan se om den er ændret/uændret.
        if (this.formGroup) {
            if (this.unsubscribe$) {
                this.unsubscribe$.unsubscribe();
            }
            this.unsubscribe$ = this.formGroup.valueChanges.subscribe(() => {
                const nyStatus = this.formGroup.dirty ? EntitetStatus.Aendret : EntitetStatus.Uaendret;
                const aktuelStatus = this.formGroup.get("status").value;
                if (nyStatus !== aktuelStatus) {
                    this.formGroup.get("status").setValue(nyStatus);
                }
            });
        }
    }

    public ngOnDestroy(): void {
        if (this.unsubscribe$) {
            this.unsubscribe$.unsubscribe();
        }
    }
}
